/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the options for how changes to column properties are animated.
 */
export var ColumnPropertyUpdatingAnimationMode = /*@__PURE__*/ (function (ColumnPropertyUpdatingAnimationMode) {
    /**
     * Automatically decides on the animation mode to use.
     */
    ColumnPropertyUpdatingAnimationMode[ColumnPropertyUpdatingAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    ColumnPropertyUpdatingAnimationMode[ColumnPropertyUpdatingAnimationMode["None"] = 1] = "None";
    /**
     * The previous value and the next value are interpolated between.
     */
    ColumnPropertyUpdatingAnimationMode[ColumnPropertyUpdatingAnimationMode["Interpolate"] = 2] = "Interpolate";
    /**
     * Deep values within the previous and next value are interpolated between.
     */
    ColumnPropertyUpdatingAnimationMode[ColumnPropertyUpdatingAnimationMode["InterpolateDeep"] = 3] = "InterpolateDeep";
    return ColumnPropertyUpdatingAnimationMode;
})({});
/**
 * @hidden
 */
export var ColumnPropertyUpdatingAnimationMode_$type = /*@__PURE__*/ markEnum('ColumnPropertyUpdatingAnimationMode', 'Auto,0|None,1|Interpolate,2|InterpolateDeep,3');
//# sourceMappingURL=ColumnPropertyUpdatingAnimationMode.js.map
